import { render, staticRenderFns } from "./waitDetailDialog.vue?vue&type=template&id=7c1722db&scoped=true"
import script from "./waitDetailDialog.vue?vue&type=script&lang=js"
export * from "./waitDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./waitDetailDialog.vue?vue&type=style&index=0&id=7c1722db&prod&lang=less"
import style1 from "./waitDetailDialog.vue?vue&type=style&index=1&id=7c1722db&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1722db",
  null
  
)

export default component.exports